import React, { createContext, useReducer, useEffect, useState } from 'react';
import app from '../feathers';
import reducer from '../util/reducer';

import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import Layout from '../pages/Layout';
import messages_en from '../translations/en.json';
import messages_fr from '../translations/fr.json';
import messages_nl from '../translations/nl.json';
import message_de from '../translations/de.json';
import message_it from '../translations/it.json';
import TMWithRoot from '../lib/Theme/TMWithRoot';
import { ProgressBarProvider } from '../context/ProgressBarProvider';
import { LanguageProvider, LanguageContext } from '../context/LanguageProvider';
import { DrawerProvider } from '../context/DrawerProvider';
import { DialogProvider } from '../context/DialogProvider';
import { ImprovedDialogProvider } from '../context/ImprovedDialogProvider';
import { ProgressDialogProvider } from '../context/ProgressDialogProvider';
import { AlertDialogProvider } from '../context/AlertDialogProvider';

const languages = {
  de: message_de,
  en: messages_en,
  fr: messages_fr,
  it: message_it,
  nl: messages_nl,
};

const AuthenticationContext = createContext();

const initialState = {
  accessToken: null,
  user: null,
  authenticationFailed: false,
};

const AuthenticationProvider = (props) => {
  const [{ accessToken, user, authenticationFailed }, dispatch] = useReducer(reducer, initialState);

  // trigger authentication
  const resetAuthentication = () => {
    if (window.localStorage.getItem('tmining_wallet') !== null) {
      try {
        const walletInfo = JSON.parse(window.localStorage.getItem('tmining_wallet'))
        if (walletInfo.url && walletInfo.url !== "0") {
          console.log("Authenticating ...")
          app.authenticate().then(auth => {
            let failed = true;
            if (auth.accessToken && auth.user) {
              failed = false;
            }
            dispatch({ payload: { accessToken: auth.accessToken, user: auth.user, authenticationFailed: failed } });
            console.log("accessToken aquired")
          }).catch(error => {
            console.error("Could not aquire accessToken")
            console.error(error);
            dispatch({ payload: { accessToken: null, user: null, authenticationFailed: true } });
          });
        } else {
          if (walletInfo.url === "0") {
            return;
          } else {
            console.error("wallet URL missing in tmining_wallet entry")
            dispatch({ payload: { accessToken: null, user: null, authenticationFailed: true } });
          }
        }
      } catch (err) {
        console.error("Could not getItem tmining_wallet")
        console.error(err);
        dispatch({ payload: { accessToken: null, user: null, authenticationFailed: true } });
      }
    }
  };

  return (
    <AuthenticationContext.Provider value={{ accessToken, user, authenticationFailed }}>
      <ProgressBarProvider>
        <LanguageProvider>
          <LanguageContext.Consumer>
            {(value) => (
              <IntlProvider
                locale={value.language}
                messages={languages[value.language]}
              >
                <DrawerProvider>
                  <DialogProvider>
                    <ImprovedDialogProvider>
                      <ProgressDialogProvider>
                        <AlertDialogProvider>
                          <SnackbarProvider maxSnack={5} hideIconVariant preventDuplicate>
                            <Layout resetAuthentication={resetAuthentication}/>
                          </SnackbarProvider>
                        </AlertDialogProvider>
                      </ProgressDialogProvider>
                    </ImprovedDialogProvider>
                  </DialogProvider>
                </DrawerProvider>
              </IntlProvider>
            )}
          </LanguageContext.Consumer>
        </LanguageProvider>
      </ProgressBarProvider>
    </AuthenticationContext.Provider>
  );
};

export { AuthenticationContext, AuthenticationProvider };
